import { Component, defineAsyncComponent } from "vue";

export const VueBrowse = defineAsyncComponent(() => import(/* webpackChunkName: "skyVue.vuebrowse" */ "../skyVue/browse/browse"));
export const BarChart = defineAsyncComponent(() => import(/* webpackChunkName: "skyVue.barchart" */ "./chart/chartTypes/barChart/barChart"));
export const LineChart = defineAsyncComponent(() => import(/* webpackChunkName: "skyVue.linechart" */ "./chart/chartTypes/lineChart/lineChart"));
export const PieChart = defineAsyncComponent(() => import(/* webpackChunkName: "skyVue.piechart" */ "./chart/chartTypes/pieChart/pieChart"));
export const VueDashboardItem = defineAsyncComponent(() => import(/* webpackChunkName: "skyVue.vueDashboardItem" */ "./dashboardItem/dashboardItem"));
export const VueDashboard = defineAsyncComponent(() => import(/* webpackChunkName: "skyVue.vueDashboard" */ "./dashboard/dashboard"));

export const SkyVueTypes: { [index: string]: Component } =
{
    vuebrowse: VueBrowse,
    barchart: BarChart,
    horizontalbarchart: BarChart,
    linechart: LineChart,
    piechart: PieChart,
    dashboarditem: VueDashboardItem,
    dashboard: VueDashboard
}
